import { CONFIG } from '../config';
export const API_URL = CONFIG.API_URL;

export const apiFetch = async (endpoint, options = {}) => {
  const headers = { ...options.headers };

  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  // ВАЖНО: Мы убрали Authorization header. 
  // Вместо этого используем credentials: 'include' для кук.
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
    credentials: 'include', 
  });

  if (response.status === 401 && !endpoint.includes('/login')) {
    window.location.href = '/admin/login';
  }

  return response;
};
